import React, {useEffect, useState} from "react";
import { useObjectStore } from "../zustand/objects";
import {Box} from "@mui/material/";
import RedoIcon from '@mui/icons-material/Redo';
import { Card, Button,  Switch, Text, Group, Slider, ActionIcon } from '@mantine/core';


const RedoButton = () => {
  const {
    redoActions,
    arrangeUndoRedo,
    sendUpdateToChannel
  } = useObjectStore();


  const asyncRedo = async (data) => {
    arrangeUndoRedo(data)
   }


  const handleRedoClick = () => {
    const data = redoActions[0]
    asyncRedo(data).then(() => 
    sendUpdateToChannel(data))
  }


  return (
          <ActionIcon disabled={redoActions.length <= 0}
          size={'sm'}
          onClick={() => handleRedoClick()}
          // onClick={() => redoRemake()}
          variant="transparent"
          color="#606060ff"
          bg={'none'}
          >
            <RedoIcon fontSize={'medium'} />
          </ActionIcon>
  );
};

export default RedoButton;
